var map = {
	"./Accordion": [
		646,
		9,
		646
	],
	"./Accordion.js": [
		646,
		9,
		646
	],
	"./AccordionSection": [
		758,
		9,
		758
	],
	"./AccordionSection.ts": [
		758,
		9,
		758
	],
	"./Animations": [
		784,
		9
	],
	"./Animations.ts": [
		784,
		9
	],
	"./AwardsSwiper": [
		917,
		9,
		96,
		917
	],
	"./AwardsSwiper.ts": [
		917,
		9,
		96,
		917
	],
	"./CountUp": [
		941,
		9,
		941
	],
	"./CountUp.ts": [
		941,
		9,
		941
	],
	"./Disclaimer": [
		244,
		9
	],
	"./Disclaimer.ts": [
		244,
		9
	],
	"./DummyClass": [
		507,
		9,
		507
	],
	"./DummyClass.ts": [
		507,
		9,
		507
	],
	"./FeaturedPostsSwiper": [
		722,
		9,
		96,
		722
	],
	"./FeaturedPostsSwiper.ts": [
		722,
		9,
		96,
		722
	],
	"./InsightModalForm": [
		332,
		9,
		96,
		332
	],
	"./InsightModalForm.ts": [
		332,
		9,
		96,
		332
	],
	"./LanguageDialog": [
		131,
		9
	],
	"./LanguageDialog.tsx": [
		131,
		9
	],
	"./LanguageSwitcher": [
		210,
		9
	],
	"./LanguageSwitcher.ts": [
		210,
		9
	],
	"./LogosSwiper": [
		527,
		9,
		96,
		527
	],
	"./LogosSwiper.ts": [
		527,
		9,
		96,
		527
	],
	"./OfficesSection": [
		895,
		9,
		895
	],
	"./OfficesSection.ts": [
		895,
		9,
		895
	],
	"./PageNavigation": [
		654,
		7
	],
	"./PageNavigation.ts": [
		654,
		7
	],
	"./PostCardsSwiper": [
		234,
		9,
		96,
		234
	],
	"./PostCardsSwiper.ts": [
		234,
		9,
		96,
		234
	],
	"./TestimonialSwiper": [
		516,
		9,
		96,
		516
	],
	"./TestimonialSwiper.ts": [
		516,
		9,
		96,
		516
	],
	"./TombstonesSwiper": [
		459,
		9,
		96,
		459
	],
	"./TombstonesSwiper.ts": [
		459,
		9,
		96,
		459
	],
	"./definition": [
		882,
		9
	],
	"./definition.ts": [
		882,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 384;
module.exports = webpackAsyncContext;